import JsonEditor from './JsonEditor';

export default JsonEditor;
